import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import "./Non_Work_Form.css";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";
import { useState } from "react";
function Non_Work_Form({handleClose}) {
   const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        <div className="row">

          {/* Record No */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Record No.</Form.Label>
              <Form.Control placeholder="Enter NCR [Year]/[Sequential Number]" />
            </Form.Group>
          </div>

          {/* Date Raised */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Date Raised</Form.Label>
              <Form.Control type="date" />
            </Form.Group>
          </div>

          {/* Dept / Area */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Dept./Area</Form.Label>
              <Form.Select>
                <option>Select Dept./Area</option>
                <option>Lab Area</option>
                <option>Quality</option>
                <option>Production</option>
              </Form.Select>
            </Form.Group>
          </div>

          {/* Non-Conformity Statement */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Non-Conformity Statement</Form.Label>
              <Form.Control placeholder="Enter Statement" />
            </Form.Group>
          </div>

          {/* Clause / Document Violated */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Clause / Document Violated</Form.Label>
              <Form.Control placeholder="eg. ISO/IEC 17025:2017, Clause 7.5" />
            </Form.Group>
          </div>

          {/* Initial Action Taken */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Initial Action Taken</Form.Label>
              <Form.Control placeholder="Action Taken" />
            </Form.Group>
          </div>

          {/* Root Cause Analysis */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Root Cause Analysis</Form.Label>
              <Form.Control placeholder="Root Cause Analysis" />
            </Form.Group>
          </div>

          {/* Corrective Action Proposed */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Corrective Action Proposed</Form.Label>
              <Form.Control placeholder="Corrective Action Proposed" />
            </Form.Group>
          </div>

          {/* Responsibility */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Responsibility</Form.Label>
              <Form.Control placeholder="Responsibility" />
            </Form.Group>
          </div>

          {/* Target Date */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Target Date</Form.Label>
              <Form.Control type="date" />
            </Form.Group>
          </div>

          {/* Attached File */}
          <div className="col-md-4">
            <Form.Group className="form_group file_field">
              <Form.Label>Attached File</Form.Label>
              <div className="absolute_fields">
                <Form.Control placeholder="Upload File" disabled />
                <div className="upload_icon_holder">
                  <FontAwesomeIcon icon={faUpload} />
                </div>
              </div>
            </Form.Group>
          </div>
        </div>

        {/* Buttons */}
         <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
      </div>
    </section>
  );
}

export default Non_Work_Form;
